<script setup>
import { ref } from 'vue';
import ErrorSmall    from "@/components/form/ErrorSmall.vue";
import LabelForInput from "@/components/form/LabelForInput.vue";
import DeleteInputIcon from "@/components/form/DeleteInputIcon.vue";
const props = defineProps({
  hint: "",
  label: "",
  name: "",
  required: "",
  error: "",
  suggestions: Array,
});

const emit = defineEmits(['validate', 'done']);
const value = defineModel();
const selectedIndex = ref(null);

const isOpen = ref(false);
function onInput() {
  isOpen.value = true;
}

function moveSelectedIndex(increment) {
  if (selectedIndex.value === null) {
    selectedIndex.value = 0;
  }
  else {
    selectedIndex.value = selectedIndex.value  + increment;
    if (selectedIndex.value < 0) {
      selectedIndex.value = props.suggestions.length-1;
    }
    else if (selectedIndex.value > props.suggestions.length-1) {
      selectedIndex.value = 0;
    }
  }
}

function setSelected(result) {
  value.value = result.name;
  isOpen.value = false;
}

</script>

<template>
  <div :class="['form-group', required && 'required']">
    <LabelForInput :name :hint :label />
    <div>
      <div class="input-container">
        <input
          type="text"
          :name
          :id="name"
          :required
          :class="['form-control', error && 'is-invalid']"
          v-model="value"
          @blur="$emit('validate', $event)"
          @input="onInput"

          @keydown.down="moveSelectedIndex(1)"
          @keydown.up="moveSelectedIndex(-1)"
          @keydown.enter.prevent="
            setSelected(suggestions[selectedIndex]);
            $emit('done', suggestions[selectedIndex].uid)"
        />
        <DeleteInputIcon v-if="error" @clearInput="value = ''" />
      </div>
    </div>
    <ul
      v-show="isOpen"
      class="company-search-suggestions"
    >
      <li
        :class="['company-search-item', index === selectedIndex && 'company-selected']"
        v-for="(suggestion, index) in suggestions"
        :key="index"
        @click="setSelected(suggestion); $emit('done', suggestion.uid)"
      >
        {{ suggestion.name }}
      </li>
    </ul>
    <ErrorSmall :name :error :label/>
  </div>
</template>

<style>
  .company-search-suggestions {
    position: absolute;
    z-index: 999;
    padding: 0;
    margin: 0;
    border: 1px solid #999999;
    background-color: white;
    max-height: 200px;
    overflow-y: auto;
  }

  .company-search-item {
    cursor: pointer;
    padding: 12px 16px;
  }

  .company-selected {
    background-color: #ffefe6;
  }

</style>
